import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ga } from 'helpers/multitrack';
import { segment } from 'helpers/segment';
import { BaseCtaWithLink } from './BaseCtaWithLink';

export const ReactivateCta = ({ schedule, ...props }) => (
  <BaseCtaWithLink
    {...props}
    className="bt--primary bt--outline"
    to="/rejoin"
    onClick={() => {
      segment.track('Venue Details', {
        action: 'Schedule Join Click',
        label: schedule.id,
      });
      ga('Venue Details', 'Schedule Join Click', schedule.id);
    }}>
    <FormattedMessage id="schedule.row.cta-join" defaultMessage="Join" />
  </BaseCtaWithLink>
);

ReactivateCta.propTypes = {
  schedule: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }),
};
